import React, { useState } from "react";
import EnglandFlag from "../Assets/Images/united-kingdom.png";
import ArabicFlag from "../Assets/Images/saudi-arabia.png";
import i18n from "../i18n";
import CustomDropdown from "./CustomDropdown";
const LanguageDropdown = () => {
  const [selectedLanguage, setSelectedLanguage] = useState({
    label: "English",
    value: "en",
    flagIcon: EnglandFlag,
  });
  const changeLanguage = (language) => {
    setSelectedLanguage(language);
    i18n.changeLanguage(language.value);
  };
  const languageArray = [
    { label: "English", value: "en", flagIcon: EnglandFlag },
    { label: "Arabic", value: "ar", flagIcon: ArabicFlag },
  ];
  return (
    <CustomDropdown
      options={languageArray}
      selected={selectedLanguage}
      onOptionSelect={changeLanguage}
    />
  );
};

export default LanguageDropdown;
